/**
 * Indicates if the code is running in a server-side environment.
 */
// eslint-disable-next-line no-restricted-globals
export const isServerSideRendering = () => typeof window === 'undefined';
